import { CodeResentInfo } from './CodeResent.info';
import { RecoveryCodeResentInfo } from './RecoveryCodeResent.info';

export type InfoMessageTypes = 'CodeResentInfo' | 'RecoveryCodeResentInfo';

export const InfoMap: Record<InfoMessageTypes, React.FC<any>> = {
    CodeResentInfo: CodeResentInfo,
    RecoveryCodeResentInfo: RecoveryCodeResentInfo,
};
